import React, { Component } from 'react';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
import gtag, { install } from 'ga-gtag';

// ユーザー特定のための乱数生成
const l = 16;
const c = "abcdefghijklmnopqrstuvwxyz0123456789";
const cl = c.length;
let r = "";
for(let i=0; i<l; i++) {
  r += c[Math.floor(Math.random()*cl)];
}
const uuid = r

export default class Web extends Component {
  constructor (props) {
    super(props);

    this.state = {
      mec_group_limited: true,
      exp_date: ""
    };
  }

  componentDidMount () {
    if ("30min.page" === document.domain) {
      ReactGA.initialize('UA-184751599-1', {gaOptions: {userId: uuid}});
      ReactGA.pageview(window.location.pathname + window.location.search);

      install('AW-404081375');
      gtag('config', 'AW-404081375');
      
      ReactPixel.init('750234562329469');
      ReactPixel.pageView();
    }

    var id = this.props.match.params.id
    if (id?.substr(0, 4) === "2022" || id?.substr(0, 3) === "2nd") {
      this.setState({exp_date: "4月24日(日)"});
    }
    if (id?.substr(0, 7) === "posting" || id?.substr(0, 4) === "wide") {
      this.setState({mec_group_limited: false})
    }
  }

  send() {
    //window.location.href = "http://30min-7085787.hs-sites.com/%E5%AE%9A%E6%9C%9F%E5%A5%91%E7%B4%84%E7%94%B3%E8%BE%BC-0";
    this.props.history.push({
      pathname: "/trial_pc_form",
      state: { uuid: uuid, campaign: window.location.pathname }
    });
  }

  area() {
    window.location.href = "https://30min.page/#area"
  }

  price() {
    window.location.href = "https://30min.page/#courses_and_fees"
  }

  inquiry() {
    window.location.href = "mailto:thirty-min@mec.co.jp";
  }

  covid() {
    window.location.href = "https://f.hubspotusercontent30.net/hubfs/7085787/%E6%96%B0%E5%9E%8B%E3%82%B3%E3%83%AD%E3%83%8A%E3%82%A6%E3%82%A3%E3%83%AB%E3%82%B9%E3%81%AB%E4%BF%82%E3%82%8B%E5%AF%BE%E5%BF%9C%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6.pdf"
  }

  render () {
    return (
    <div className="web home">
      <div className="content-wrapper">
        <div className="trial-web">

          <div className="kv">
            <picture>
              <source media="(max-width: 480px)" srcSet={this.state.mec_group_limited ? "/images/lp/lp/kv_sp.png" : "/images/lp/trial/kv_sp.png"} />
              <img src={this.state.mec_group_limited ? "/images/lp/lp/kv2_web.png" : "/images/lp/trial/kv2_web.png" } alt="日々の家事。私たちと、ときどき、交代しませんか。" />
            </picture>
          </div>

          <div className="about">
            <picture>
              <source media="(max-width: 480px)" srcSet="/images/lp/lp/about_sp.png" />
              <img src="/images/lp/lp/about.png" alt="日々の家事。私たちと、ときどき、交代しませんか。" />
            </picture>
          </div>
          
          <div className="campaign-wrapper">
            <div className="campaign">
              <picture>
                <source media="(max-width: 480px)" srcSet="/images/lp/trial/price_sp.png" />
                <img src="/images/lp/trial/price.png" alt="日々の家事。私たちと、ときどき、交代しませんか。" />
              </picture>
              <div className="prices">
                <div className="price">
                  <div className="title"><span>60</span>分お試し</div>
                  <div className="body">
                    <div>
                      <p>通常料金</p>
                      <p><span>4,400</span>円</p>
                    </div>
                    <div />
                    <div>
                      <p>初回お試し料金</p>
                      <p><span>3,300</span>円</p>
                    </div>
                  </div>
                </div>
                <div className="price">
                  <div className="title"><span>120</span>分お試し</div>
                  <div className="body">
                    <div>
                      <p>通常料金</p>
                      <p><span>8,800</span>円</p>
                    </div>
                    <div />
                    <div>
                      <p>初回お試し料金</p>
                      <p><span>5,500</span>円</p>
                    </div>
                  </div>
                </div>
                <div className="price">
                  <div className="title"><span>180</span>分お試し</div>
                  <div className="body">
                    <div>
                      <p>通常料金</p>
                      <p><span>12,650</span>円</p>
                    </div>
                    <div />
                    <div>
                      <p>初回お試し料金</p>
                      <p><span>8,800</span>円</p>
                    </div>
                  </div>
                </div>
              </div>
              <p className="description">※料金は<span>交通費込</span>・税込総額表示となります。</p>
              <p className="description">※通常料金はご利用頻度によって異なります。</p>
              {this.state.exp_date && 
                <div className="price-bottom">
                  <div className="balloon">期間限定</div>
                  <span className="exp-text"><span>{this.state.exp_date}</span>までにキャンペーンお申し込みの場合、<br />お試し後、定期利用される方は<span>定期利用の初回が無料</span>に！</span>
                  <span className="exp-text-sp"><span>{this.state.exp_date}</span>までにお申込みの場合<br />お試し後、定期利用する方は<span>定期初回が無料！</span></span>
                </div>
              }
              <div className="cv-button">
                <button onClick={this.send.bind(this)}>お申し込みはコチラ</button>
              </div>
            </div>
          </div>

          <div className="content bottom-space">
            <p className="content-title top-space bottom-space">30min.の家事代行は、<br />ココが違います！</p>
            <div className="inner-img">
              <picture>
                <source media="(max-width: 480px)" srcSet="/images/lp/lp/points_sp.png" />
                <img src="/images/lp/lp/points.png" alt="お試しキャンペーン特典　1回あたり2750円　最大6600円お得！" />
              </picture>
            </div>
          </div>

          <div className="content bottom-space">
            <div className="inner-img">
              <picture>
                <source media="(max-width: 480px)" srcSet="/images/lp/lp/place_sp.png" />
                <img src="/images/lp/lp/place.png" alt="お試しキャンペーン特典　1回あたり2750円　最大6600円お得！" />
              </picture>
            </div>
          </div>

          <div className="content bottom-space">
            <div className="inner-img">
              <picture>
                <source media="(max-width: 480px)" srcSet="/images/lp/lp/voices_sp.png" />
                <img src="/images/lp/lp/voices.png" alt="お試しキャンペーン特典　1回あたり2750円　最大6600円お得！" />
              </picture>
            </div>
          </div>

          <div className="content bottom-space-long">
            <p className="content-title top-space bottom-space">お申し込み手順</p>
            <div className="inner-img">
              <picture>
                <source media="(max-width: 480px)" srcSet="/images/lp/lp/flow_sp.png" />
                <img src="/images/lp/lp/flow.png" alt="お試しキャンペーン特典　1回あたり2750円　最大6600円お得！" />
              </picture>
            </div>
          </div>

          <div className="campaign-wrapper">
            <div className="campaign">
              <picture>
                <source media="(max-width: 480px)" srcSet="/images/lp/trial/price_sp.png" />
                <img src="/images/lp/trial/price.png" alt="日々の家事。私たちと、ときどき、交代しませんか。" />
              </picture>
              <div className="prices">
                <div className="price">
                  <div className="title"><span>60</span>分お試し</div>
                  <div className="body">
                    <div>
                      <p>通常料金</p>
                      <p><span>4,400</span>円</p>
                    </div>
                    <div />
                    <div>
                      <p>初回お試し料金</p>
                      <p><span>3,300</span>円</p>
                    </div>
                  </div>
                </div>
                <div className="price">
                  <div className="title"><span>120</span>分お試し</div>
                  <div className="body">
                    <div>
                      <p>通常料金</p>
                      <p><span>8,800</span>円</p>
                    </div>
                    <div />
                    <div>
                      <p>初回お試し料金</p>
                      <p><span>5,500</span>円</p>
                    </div>
                  </div>
                </div>
                <div className="price">
                  <div className="title"><span>180</span>分お試し</div>
                  <div className="body">
                    <div>
                      <p>通常料金</p>
                      <p><span>12,650</span>円</p>
                    </div>
                    <div />
                    <div>
                      <p>初回お試し料金</p>
                      <p><span>8,800</span>円</p>
                    </div>
                  </div>
                </div>
              </div>
              <p className="description">※料金は<span>交通費込</span>・税込総額表示となります。</p>
              <p className="description">※通常料金はご利用頻度によって異なります。</p>
              {this.state.exp_date && 
                <div className="price-bottom">
                  <div className="balloon">期間限定</div>
                  <span className="exp-text"><span>{this.state.exp_date}</span>までにキャンペーンお申し込みの場合、<br />お試し後、定期利用される方は<span>定期利用の初回が無料</span>に！</span>
                  <span className="exp-text-sp"><span>{this.state.exp_date}</span>までにお申込みの場合<br />お試し後、定期利用する方は<span>定期初回が無料！</span></span>
                </div>
              }
              <div className="cv-button">
                <button onClick={this.send.bind(this)}>お申し込みはコチラ</button>
              </div>
            </div>
          </div>

          <div className="content">
            <div className="inner-img">
              <picture>
                <source media="(max-width: 480px)" srcSet="/images/lp/lp/results_sp.png" />
                <img src="/images/lp/lp/results.png" alt="お試しキャンペーン特典　1回あたり2750円　最大6600円お得！" />
              </picture>
            </div>
          </div>

          <div className="sub-button">
            <div className="buttons">
              <button onClick={this.area.bind(this)} className="left-button">サービスご提供エリア・マンションはこちら</button>
              <button onClick={this.price.bind(this)}>定期利用の料金はこちら</button>
            </div>
          </div>

          <div className="content bottom-space-long">
            <p className="content-title top-space bottom-space">よくあるご質問</p>
            <div className="faqs">
              <div className="faq">
                <div>
                  <p>Q</p>
                  <p>ハウスクリーニングとの違いは？</p>
                </div>
                <div>
                  <p>A</p>
                  <p>プロが利用する洗剤・機材を持ち込み、専門の技術を持ったプロが清掃するハウスクリーニングとは異なり、 家事代行サービスは、お客様がお持ちの道具・洗剤をお借りし、お客様の代わりに家事代行スタッフが日常的な家事をおこないます。</p>
                </div>
              </div>
              <div className="faq">
                <div>
                  <p>Q</p>
                  <p>道具はどのようなものを使うのですか？家に掃除道具を用意していた方が良いですか。</p>
                </div>
                <div>
                  <p>A</p>
                  <p>家事代行サービスは、お客様宅にあるお掃除道具類をお借りしてのサービスとなりますため、ご用意をお願いします。ご用意いただきたい掃除道具は<a href="https://f.hubspotusercontent30.net/hubfs/7085787/%E3%81%94%E5%88%A9%E7%94%A8%E3%81%AE%E6%89%8B%E5%BC%95%E3%81%8D201130.pdf">こちら</a>をご確認ください。</p>
                </div>
              </div>
              <div className="faq">
                <div>
                  <p>Q</p>
                  <p>どのような人が来ますか？</p>
                </div>
                <div>
                  <p>A</p>
                  <p>お客様に安心してサービスをご利用いただけるように、30min.では採用と育成の仕組みを作っております。採用時に経歴の確認及び当社の選考基準に基づく面接、研修に合格したスタッフのみが正式なハウスキーパーとして、お客様のご自宅にお伺いいたします。</p>
                </div>
              </div>
              <div className="faq">
                <div>
                  <p>Q</p>
                  <p>ペットを飼っています。サービス中は、ペットをどうすればよいですか？</p>
                </div>
                <div>
                  <p>A</p>
                  <p>事故防止、逃走防止のため、サービス中は基本的にケージ内に入れていただくか、清掃をしないお部屋での対応をお願いします。</p>
                </div>
              </div>
            </div>
          </div>

          <div className="sub-button">
            <button onClick={this.covid.bind(this)}>コロナ対策について</button>
          </div>

          <div className="campaign-wrapper">
            <div className="campaign">
              <picture>
                <source media="(max-width: 480px)" srcSet="/images/lp/trial/price_sp.png" />
                <img src="/images/lp/trial/price.png" alt="日々の家事。私たちと、ときどき、交代しませんか。" />
              </picture>
              <div className="prices">
                <div className="price">
                  <div className="title"><span>60</span>分お試し</div>
                  <div className="body">
                    <div>
                      <p>通常料金</p>
                      <p><span>4,400</span>円</p>
                    </div>
                    <div />
                    <div>
                      <p>初回お試し料金</p>
                      <p><span>3,300</span>円</p>
                    </div>
                  </div>
                </div>
                <div className="price">
                  <div className="title"><span>120</span>分お試し</div>
                  <div className="body">
                    <div>
                      <p>通常料金</p>
                      <p><span>8,800</span>円</p>
                    </div>
                    <div />
                    <div>
                      <p>初回お試し料金</p>
                      <p><span>5,500</span>円</p>
                    </div>
                  </div>
                </div>
                <div className="price">
                  <div className="title"><span>180</span>分お試し</div>
                  <div className="body">
                    <div>
                      <p>通常料金</p>
                      <p><span>12,650</span>円</p>
                    </div>
                    <div />
                    <div>
                      <p>初回お試し料金</p>
                      <p><span>8,800</span>円</p>
                    </div>
                  </div>
                </div>
              </div>
              <p className="description">※料金は<span>交通費込</span>・税込総額表示となります。</p>
              <p className="description">※通常料金はご利用頻度によって異なります。</p>
              {this.state.exp_date && 
                <div className="price-bottom">
                  <div className="balloon">期間限定</div>
                  <span className="exp-text"><span>{this.state.exp_date}</span>までにキャンペーンお申し込みの場合、<br />お試し後、定期利用される方は<span>定期利用の初回が無料</span>に！</span>
                  <span className="exp-text-sp"><span>{this.state.exp_date}</span>までにお申込みの場合<br />お試し後、定期利用する方は<span>定期初回が無料！</span></span>
                </div>
              }
              <div className="cv-button">
                <button onClick={this.send.bind(this)}>お申し込みはコチラ</button>
              </div>
            </div>
          </div>

          <div className="precautions">
            <div className="precaution">
              <p className="precaution-title">【料金のお支払いについて】</p>
              <p>・ご利用料金のお支払いは、サービスご提供後の後払い、クレジットカード決済となります。</p>
            </div>
            <div className="precaution">
              <p className="precaution-title">【ご利用にあたっての注意事項】</p>
              <p>・お試し利用のサービス時には、ご在宅いただく必要がございます。</p>
              <p>・本キャンペーンは、初めて30min.をご利用のお客様に限ります。</p>
              <p>・お掃除箇所の広さ、汚れ具合、ご用意いただいたお掃除道具等によっては、お掃除ができない箇所がある場合がございます。</p>
              <p>・サービスご利用日時変更・キャンセルは、サービス日３日前の正午までにご連絡ください。</p>
              <p>・本キャンペーンは予告なく変更・終了する場合があります。予めご了承ください。</p>
            </div>
            <div className="precaution">
              <p className="precaution-title">【その他】</p>
              <p>・記載の通常料金について、60分は月2回の頻度、120分・180分は月1回の頻度にて定期利用した場合の料金となります。ご利用頻度によって定期利用の料金が異なります。</p>
            </div>
          </div>

          <div className="footer">
            <img className="inner-img" src="/images/homepage/logo.png" alt="" />
            <div className="sub-button">
              <button onClick={this.inquiry.bind(this)} className="background6">お問い合わせはコチラ</button>
            </div>
            <img className="phrase_logo" src="/images/lp/lp/mec.png" alt="" />
            <div className="links">
              <ul>
                <li><a href="/">30min.　</a></li>
                <li><a href="https://f.hubspotusercontent30.net/hubfs/7085787/%E7%89%B9%E5%AE%9A%E5%95%86%E5%8F%96%E5%BC%95%E3%81%AB%E4%BF%82%E3%82%8B%E6%A8%99%E8%A8%98.pdf">特定商取引に基づく表記</a></li>
                <li><a href="https://www.mec.co.jp/j/privacy/">プライバシーポリシー</a></li>
                <li><a href="https://www.mec.co.jp/">運営会社</a></li>
              </ul>
              <div className="text-4 copyright">Copyright © MITSUBISHI ESTATE Co., Ltd. All Rights Reserved.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    );
  }
}